import { useMutation } from "@tanstack/react-query";
import { AxiosRequestConfig } from "axios";
import axios from "../../../../services/department-viags/config.service";
import { BaseResponse } from "../../../chats/types";

interface CreateFolderSchema {
  parentKey?: string;
  key: string;
  name: string;
  position?: number;
  isPublicFolder: boolean;
}

const BASE_PATH = "/edoc";

const folderApi = {
  create: async (body: CreateFolderSchema, config?: AxiosRequestConfig) => {
    await axios.post<BaseResponse<unknown>>(`${BASE_PATH}/create-folder`, body, config);
  },
};

const useCreateFolder = () => {
  return useMutation({
    mutationFn: (body: CreateFolderSchema) => folderApi.create(body),
  });
};

export default useCreateFolder;
